// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fm-0";
export var headerCellHover = "_fm-1";
export var readCellContainer = "_fm-2";
export var unreadIndicator = "_fm-3";